<template>
  <section>

  <v-dialog v-model="show" persistent scrollable max-width="560px">
    <v-card>
      <v-card-text>
        <p class="text-h5 text-center mt-4">Настройки</p>
        <v-divider/>
        <div style="height: 10px;"></div>
        <!-- <p style="margin-bottom: 15px;" class="indigo--text"><b>Параметры локального хранилища:</b></p> -->
        <span class="text-subtitle-2">На устройстве доступно: <b class="green--text">{{ storageParams.quota }}</b></span><br>
        <span class="text-subtitle-2">Использовано: <b class="blue--text">{{ storageParams.usage }}</b></span>
        <span><b class="blue--text"> ({{ this.storageParams.usagePercent }}%)</b></span>
        <div style="height: 10px;"></div>
        <span class="text-subtitle-2">Предупреждать, если сохранено более чем:</span>
        <v-select
            solo
            dense
            outlined
            label="Максимальный объем данных"
            v-model="maxDataSize"
            :items="['10 MB', '50 MB', '100 MB', '500 MB', '1 GB', 'Без ограничения',]"
        ></v-select>
        <v-divider/>
        <br>
        <span class="text-subtitle-2">Кол-во итераций определения координат:</span>
        <v-select
            solo
            dense
            outlined
            label="Кол-во итераций"
            v-model="coordsIterateNumber"
            :items="[5, 10, 20, 50, 100]"
        ></v-select>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="saveSettings" color="primary" small>
          <v-icon>mdi-check</v-icon>OK
        </v-btn>
        <v-btn @click="$emit('cancel')" color="blue-grey lighten-1" dark small>
          Отмена
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

  </section>
</template>

<script>
import common from "@/common";
import CommandPanel from "@/components/common/commandPanel";
import validations from "@/validations";
import localForage from "localforage";

export default {
  auth: true,
  name: "settings",

  components: { CommandPanel },

  data() {
    return {
      show: true,
      loading: false,
      ...validations,
      storageParams: {
        quota: 0,
        usage: 0,
        usagePercent: 0,
      },
      coordsIterateNumber: null,
      maxDataSize: null,
    }
  },

  created() {
    navigator.storage.estimate().then( (data) => {
      this.storageParams.quota = common.fileSizeFormat(data.quota);
      this.storageParams.usage = common.fileSizeFormat(data.usage, 2);
      if (data.usage > 0) this.storageParams.usagePercent = (data.usage / data.quota * 100);
      else this.storageParams.usagePercent = 100;
      if (this.storageParams.usagePercent < 1) this.storageParams.usagePercent = 'менее 1'
      else this.storageParams.usagePercent = (this.storageParams.usagePercent).toFixed(1);
    });

    common.getCoordsIterateNumber().then((res) => this.coordsIterateNumber = res)   
    common.getMaxDataSize().then((res) => this.maxDataSize = res)   
  },

  methods: {
    async saveSettings() {
      await localForage.setItem("coordsIterateNumber", this.coordsIterateNumber);
      await localForage.setItem("maxDataSize", this.maxDataSize);
      this.$emit('ok');
    },
  },

}
</script>
